
import wx from 'weixin-js-sdk'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'


export default {
name: 'deviceEdit',
components: {
wx,PopupPicker,CheckIcon,XTextarea,Group,Radio,Datetime,XSwitch
},
data() {
return {
stringValue:'',
stingTitle:'',
locations:[
{
key:0,
value:'店外（开锁成功播报）'
},
{
key:1,
value:'店内（进店后播报）'
},
],
location:1,
formData:{
id:0,
volume:1,
num:1,
location:1,
content:'',
open_state:0,
open_minute:0,
open_start_time:'开始时间',
open_end_time:'结束时间',
},
datetimeStatus:false,
datetimeStatus1:false,
colors:[
{id:1,name:'红',color:'#FE5448'},
{id:2,name:'黄',color:'#FFCD35'},
{id:3,name:'蓝',color:'#326FFA'},
{id:4,name:'绿',color:'#2ECC71'},
{id:5,name:'青',color:'#00FFFF'},
{id:6,name:'白',color:'#FFFFFF'},
{id:7,name:'紫',color:'#9B59B6'},
]
}
},
created() {
this.formData.id = Number(this.$route.params.id);
this.getDeviceInfo();
this.config();
},
computed:{

},
methods: {
changeOpenState(val){
console.log(val);
this.stingTitle = val > 0 ? '打开' : '关闭';
},
datetimeChange(val){
this.formData.open_start_time = val;
},
datetimeChange1(val){
this.formData.open_end_time = val;
},
changeLocation(val){
this.formData.location = val;
},
getDeviceInfo(){
this.$api.getDeviceInfo({id:this.formData.id}).then((res)=>{
if(res){
this.formData = Object.assign({}, this.formData, res.data);
this.location = res.data.location;
}
})
},
submit() {
this.$api.deviceSetting(this.formData).then((res)=>{
if(res.code == 0){
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);
},300)
}
});
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['qrCode'],
success: function (res) {
setTimeout(()=>{
if(res.resultStr.indexOf(",") != -1){
that.formData.code = res.resultStr.split(',')[1];
}else{
that.formData.code = res.resultStr;
}
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/deviceSetting.vue